import * as React from 'react';

import {appConfig} from "../../../settings/app";

import './index.css';

export const LoadingInLine = (title: string = ''): JSX.Element => (
	<span className="loading-inline">{title ? `...${title}` : ''} {appConfig.loadingSpinnerComponent}</span>
);
